import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RestaurantTableService } from '../../../services/restaurantTable.service';
import { CreateRestaurantTableDto } from '../../../models/dtos/createRestaurantTable.dto';
import { UpdateRestaurantTableDto } from '../../../models/dtos/updateRestaurantTable.dto';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    InputNumberModule,
  ],
  selector: 'app-form-restaurant-table',
  templateUrl: './form-restaurant-table.component.html',
  styleUrls: ['./form-restaurant-table.component.css'],
})
export class FormRestaurantTableComponent implements OnInit, AfterViewInit {
  form!: FormGroup;
  isEditMode = false;
  id?: number;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private restaurantTableService: RestaurantTableService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      number: [null as number | null, [Validators.required, Validators.min(1)]],
      active: [true],
    });

    this.id = Number(this.route.snapshot.paramMap.get('id'));
    if (this.id) {
      this.isEditMode = true;
      this.restaurantTableService.find(this.id).subscribe({
        next: (response) => {
          if (response.data) {
            this.form.patchValue({
              number: response.data.number,
              active: response.data.active !== false,
            });
            setTimeout(() => this.focusNumberInput(), 0);
          }
        },
      });
    }
  }

  ngAfterViewInit(): void {
    if (!this.isEditMode) {
      setTimeout(() => this.focusNumberInput(), 0);
    }
  }

  private focusNumberInput(attempt = 0): void {
    const maxAttempts = 8;
    const el = document.getElementById('restaurant-table-number') as HTMLInputElement | null;
    if (el && typeof el.focus === 'function') {
      el.focus();
      if (typeof el.select === 'function' && el.value) {
        el.select();
      }
      return;
    }
    if (attempt < maxAttempts) {
      setTimeout(() => this.focusNumberInput(attempt + 1), 50 * (attempt + 1));
    }
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    const value = this.form.value;

    if (this.isEditMode && this.id) {
      const dto: UpdateRestaurantTableDto = {
        number: value.number != null ? value.number : undefined,
        active: value.active,
      };
      this.restaurantTableService.update(this.id, dto).subscribe({
        next: () => this.router.navigate(['/app/restaurant/tables']),
        error: () => alert('Erro ao atualizar mesa.'),
      });
    } else {
      const dto: CreateRestaurantTableDto = { number: value.number };
      this.restaurantTableService.create(dto).subscribe({
        next: () => this.router.navigate(['/app/restaurant/tables']),
        error: () => alert('Erro ao cadastrar mesa.'),
      });
    }
  }

  goBack(): void {
    this.router.navigate(['/app/restaurant/tables']);
  }
}
